var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotifications(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41 41c-.7-1.5-1.3-3.6-1.7-6.5a57.1 57.1 0 0 1-.9-10 1.8 1.8 0 0 0-3.5.8 64.2 64.2 0 0 0 2 15.1 134.7 134.7 0 0 1-5.8.7 102.8 102.8 0 0 1-25.7-.7 66 66 0 0 0 2-15.1v-7.8a13.8 13.8 0 0 1 27.5 0 1.8 1.8 0 1 0 3.7 0 17.5 17.5 0 0 0-35 0v7.8c0 3-.2 6.2-.6 9.2-.3 2.3-1 4.5-1.8 6.6a1.8 1.8 0 0 0 1.3 2.6 104.8 104.8 0 0 0 8.3 1.1l3.7.3a7 7 0 0 0 13.2 0l3.7-.3h.3a104.8 104.8 0 0 0 8.8-1.4A1.8 1.8 0 0 0 41 41zm-19.9 5.3a3.2 3.2 0 0 1-2.4-1h4.8a3.2 3.2 0 0 1-2.4 1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 17.5a1.8 1.8 0 1 0 3.7 0 6 6 0 0 1 6-6 1.8 1.8 0 0 0 0-3.7 9.7 9.7 0 0 0-9.7 9.7z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/notifications.7a8845e6.svg";
export { ForwardRef as ReactComponent };